var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 14.833h15V16.5H.5v-1.667Zm8.333-4.856 5.06-5.06 1.178 1.178L8 13.167.93 6.096l1.177-1.18 5.06 5.059V.667h1.666v9.31Z",
    fill: "#EDE7FD"
  })));
};
export { SvgDownloadIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAxNC44MzM0SDE1LjVWMTYuNUgwLjVWMTQuODMzNFpNOC44MzMzMyA5Ljk3NjY5TDEzLjg5MjUgNC45MTY2OUwxNS4wNzA4IDYuMDk1MDJMOCAxMy4xNjY3TDAuOTI5MTY3IDYuMDk1ODVMMi4xMDc1IDQuOTE2NjlMNy4xNjY2NyA5Ljk3NTAyVjAuNjY2Njg3SDguODMzMzNWOS45NzY2OVoiIGZpbGw9IiNFREU3RkQiLz4KPC9zdmc+Cg==";